import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import {
  toWidget,
  toWidgetEditable,
} from "@ckeditor/ckeditor5-widget/src/utils"
import { enablePlaceholder } from "@ckeditor/ckeditor5-engine/src/view/placeholder"
import Widget from "@ckeditor/ckeditor5-widget/src/widget"
import InsertNextPageBox from "./insertNextPageBox"

export default class NextPageBoxEditing extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this.defineSchema()
    this.defineConvrters()
    this.editor.commands.add(
      "insertNextPageBox",
      new InsertNextPageBox(this.editor)
    )
  }

  defineSchema() {
    const schema = this.editor.model.schema

    schema.register("nextPageBox", {
      isObject: true,
      allowWhere: "$block",
    })
    schema.register("nextPageBoxLabel", {
      allowIn: "nextPageBox",
      allowContentOf: "$block",
    })
    schema.register("nextPageBoxTitle", {
      isLimit: true,
      allowIn: "nextPageBox",
      allowContentOf: "$block",
    })
  }

  defineConvrters() {
    const conversion = this.editor.conversion
    conversion.for("upcast").elementToElement({
      model: "nextPageBox",
      view: {
        name: "div",
        classes: "next-page-box",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "nextPageBox",
      view: {
        name: "div",
        classes: "next-page-box",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "nextPageBox",
      view: (modelElement, viewWriter) => {
        const section = viewWriter.createContainerElement("div", {
          class: "next-page-box",
        })

        return toWidget(section, viewWriter, { label: "next page box widget" })
      },
    })

    // <nextPageBoxLabel> converters
    conversion.elementToElement({
      model: "nextPageBoxLabel",
      view: {
        name: "label",
        classes: "next-page-box-label",
      },
    })

    // <nextPageBoxTitle> converters
    conversion.for("upcast").elementToElement({
      model: "nextPageBoxTitle",
      view: {
        name: "h3",
        classes: "next-page-box-title",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "nextPageBoxTitle",
      view: {
        name: "h3",
        classes: "next-page-box-title",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "nextPageBoxTitle",
      view: (modelElement, viewWriter) => {
        const view = viewWriter.createEditableElement("h3", {
          class: "next-page-box-title",
        })
        enablePlaceholder({
          view: this.editor.editing.view,
          element: view,
          text: "埋め込みコメント",
        })
        return toWidgetEditable(view, viewWriter)
      },
    })
  }
}
